import { Volume2, VolumeX } from "lucide-react";

export const SoundToggle = ({ on, toggle }) => (
  <button
    data-testid="sound-toggle"
    onClick={toggle}
    aria-label={on ? "Mute ambience" : "Play ambience"}
    className="flex h-9 w-9 items-center justify-center rounded-full border border-amber-200/25 bg-white/5 backdrop-blur-md transition-colors hover:border-amber-200/60 hover:bg-white/10"
  >
    {on ? (
      <Volume2 className="h-4 w-4 text-amber-200" />
    ) : (
      <VolumeX className="h-4 w-4 text-amber-100/60" />
    )}
  </button>
);
